// Asset Names Mapping
// Maps ticker symbols to their full company/asset names

export const ASSET_NAMES = {
  // US Stocks - Tech
  AAPL: 'Apple Inc.',
  MSFT: 'Microsoft Corporation',
  GOOGL: 'Alphabet Inc.',
  GOOG: 'Alphabet Inc.',
  AMZN: 'Amazon.com Inc.',
  META: 'Meta Platforms Inc.',
  NVDA: 'NVIDIA Corporation',
  TSLA: 'Tesla Inc.',
  AMD: 'Advanced Micro Devices',
  INTC: 'Intel Corporation',
  CRM: 'Salesforce Inc.',
  ORCL: 'Oracle Corporation',
  ADBE: 'Adobe Inc.',
  NFLX: 'Netflix Inc.',
  PYPL: 'PayPal Holdings',
  SHOP: 'Shopify Inc.',
  SQ: 'Block Inc.',
  UBER: 'Uber Technologies',
  LYFT: 'Lyft Inc.',
  SNAP: 'Snap Inc.',
  TWTR: 'Twitter Inc.',
  PINS: 'Pinterest Inc.',
  SPOT: 'Spotify Technology',
  ZM: 'Zoom Video',
  DOCU: 'DocuSign Inc.',
  PLTR: 'Palantir Technologies',
  SNOW: 'Snowflake Inc.',
  CRWD: 'CrowdStrike Holdings',
  NET: 'Cloudflare Inc.',
  DDOG: 'Datadog Inc.',
  MDB: 'MongoDB Inc.',
  OKTA: 'Okta Inc.',
  TWLO: 'Twilio Inc.',
  U: 'Unity Software',
  RBLX: 'Roblox Corporation',
  COIN: 'Coinbase Global',
  HOOD: 'Robinhood Markets',
  SOFI: 'SoFi Technologies',
  AFRM: 'Affirm Holdings',
  PATH: 'UiPath Inc.',
  DKNG: 'DraftKings Inc.',
  
  // US Stocks - Semiconductors
  AVGO: 'Broadcom Inc.',
  QCOM: 'QUALCOMM Inc.',
  TXN: 'Texas Instruments',
  MU: 'Micron Technology',
  MRVL: 'Marvell Technology',
  LRCX: 'Lam Research',
  KLAC: 'KLA Corporation',
  AMAT: 'Applied Materials',
  ASML: 'ASML Holding',
  TSM: 'Taiwan Semiconductor',
  ARM: 'Arm Holdings',
  VRT: 'Vertiv Holdings',
  SMCI: 'Super Micro Computer',
  
  // US Stocks - Space & Defense
  RKLB: 'Rocket Lab USA',
  SPCE: 'Virgin Galactic',
  BA: 'Boeing Company',
  LMT: 'Lockheed Martin',
  RTX: 'RTX Corporation',
  NOC: 'Northrop Grumman',
  GD: 'General Dynamics',
  
  // US Stocks - Energy
  XOM: 'Exxon Mobil',
  CVX: 'Chevron Corporation',
  SU: 'Suncor Energy',
  COP: 'ConocoPhillips',
  SLB: 'Schlumberger',
  OXY: 'Occidental Petroleum',
  
  // US Stocks - Finance
  JPM: 'JPMorgan Chase',
  BAC: 'Bank of America',
  WFC: 'Wells Fargo',
  GS: 'Goldman Sachs',
  MS: 'Morgan Stanley',
  C: 'Citigroup Inc.',
  V: 'Visa Inc.',
  MA: 'Mastercard Inc.',
  AXP: 'American Express',
  BLK: 'BlackRock Inc.',
  SCHW: 'Charles Schwab',
  
  // US Stocks - Healthcare
  JNJ: 'Johnson & Johnson',
  PFE: 'Pfizer Inc.',
  UNH: 'UnitedHealth Group',
  MRK: 'Merck & Co.',
  ABBV: 'AbbVie Inc.',
  LLY: 'Eli Lilly',
  TMO: 'Thermo Fisher',
  ABT: 'Abbott Laboratories',
  BMY: 'Bristol-Myers Squibb',
  AMGN: 'Amgen Inc.',
  GILD: 'Gilead Sciences',
  MRNA: 'Moderna Inc.',
  BNTX: 'BioNTech SE',
  
  // US Stocks - Consumer
  WMT: 'Walmart Inc.',
  COST: 'Costco Wholesale',
  TGT: 'Target Corporation',
  HD: 'Home Depot',
  LOW: "Lowe's Companies",
  NKE: 'Nike Inc.',
  SBUX: 'Starbucks',
  MCD: "McDonald's",
  DIS: 'Walt Disney',
  KO: 'Coca-Cola',
  PEP: 'PepsiCo Inc.',
  PG: 'Procter & Gamble',
  
  // US Stocks - Industrial
  CAT: 'Caterpillar Inc.',
  DE: 'Deere & Company',
  GE: 'General Electric',
  HON: 'Honeywell',
  UPS: 'United Parcel Service',
  FDX: 'FedEx Corporation',
  
  // US Stocks - EV & Auto
  F: 'Ford Motor',
  GM: 'General Motors',
  RIVN: 'Rivian Automotive',
  LCID: 'Lucid Group',
  NIO: 'NIO Inc.',
  XPEV: 'XPeng Inc.',
  LI: 'Li Auto Inc.',
  
  // Crypto
  BTC: 'Bitcoin',
  'BTC-USD': 'Bitcoin',
  'BTC/USD': 'Bitcoin',
  BTCUSD: 'Bitcoin',
  ETH: 'Ethereum',
  'ETH-USD': 'Ethereum',
  'ETH/USD': 'Ethereum',
  ETHUSD: 'Ethereum',
  SOL: 'Solana',
  'SOL-USD': 'Solana',
  SOLUSD: 'Solana',
  BNB: 'Binance Coin',
  XRP: 'Ripple',
  ADA: 'Cardano',
  DOGE: 'Dogecoin',
  DOT: 'Polkadot',
  AVAX: 'Avalanche',
  MATIC: 'Polygon',
  LINK: 'Chainlink',
  UNI: 'Uniswap',
  ATOM: 'Cosmos',
  LTC: 'Litecoin',
  SHIB: 'Shiba Inu',
  NEAR: 'NEAR Protocol',
  APT: 'Aptos',
  ARB: 'Arbitrum',
  OP: 'Optimism',
  FTM: 'Fantom',
  ALGO: 'Algorand',
  XLM: 'Stellar',
  VET: 'VeChain',
  FIL: 'Filecoin',
  HBAR: 'Hedera',
  ICP: 'Internet Computer',
  AAVE: 'Aave',
  TAO: 'Bittensor',
  HYPE: 'Hyperliquid',
  CRO: 'Cronos',
  RENDER: 'Render',
  SUI: 'Sui',
  INJ: 'Injective',
  TIA: 'Celestia',
  SEI: 'Sei',
  STX: 'Stacks',
  PEPE: 'Pepe',
  WIF: 'Dogwifhat',
  BONK: 'Bonk',
  FLOKI: 'Floki',
  WLD: 'Worldcoin',
  JUP: 'Jupiter',
  ONDO: 'Ondo Finance',
  ENA: 'Ethena',
  TON: 'Toncoin',
  PYTH: 'Pyth Network',
  
  // Forex
  EURUSD: 'Euro / US Dollar',
  'EUR/USD': 'Euro / US Dollar',
  GBPUSD: 'British Pound / US Dollar',
  'GBP/USD': 'British Pound / US Dollar',
  USDJPY: 'US Dollar / Japanese Yen',
  'USD/JPY': 'US Dollar / Japanese Yen',
  USDCHF: 'US Dollar / Swiss Franc',
  'USD/CHF': 'US Dollar / Swiss Franc',
  AUDUSD: 'Australian Dollar / US Dollar',
  'AUD/USD': 'Australian Dollar / US Dollar',
  USDCAD: 'US Dollar / Canadian Dollar',
  'USD/CAD': 'US Dollar / Canadian Dollar',
  NZDUSD: 'New Zealand Dollar / US Dollar',
  'NZD/USD': 'New Zealand Dollar / US Dollar',
  
  // Indices
  SPY: 'SPDR S&P 500 ETF',
  QQQ: 'Invesco QQQ Trust',
  DIA: 'SPDR Dow Jones',
  IWM: 'iShares Russell 2000',
  VTI: 'Vanguard Total Stock Market',
  VOO: 'Vanguard S&P 500',
  
  // Commodities
  GC: 'Gold Futures',
  'GC=F': 'Gold Futures',
  SI: 'Silver Futures',
  'SI=F': 'Silver Futures',
  CL: 'Crude Oil WTI',
  'CL=F': 'Crude Oil WTI',
  NG: 'Natural Gas',
  'NG=F': 'Natural Gas',
};

// Function to get asset name from symbol
export const getAssetName = (symbol) => {
  if (!symbol) return '';
  
  // Clean up symbol (remove exchange suffix like .PA, .L, BINANCE:, etc.)
  let cleanSymbol = symbol.split('.')[0].toUpperCase();
  cleanSymbol = cleanSymbol.replace(/^[A-Z]+:/, ''); // Remove exchange prefix like BINANCE:, NASDAQ:
  
  // Try exact match first
  if (ASSET_NAMES[cleanSymbol]) {
    return ASSET_NAMES[cleanSymbol];
  }
  
  // For crypto pairs like BTCUSDT, ETHUSDT, extract the base symbol
  const cryptoMatch = cleanSymbol.match(/^([A-Z]+)(USDT?|USD|EUR|BTC|ETH)$/);
  if (cryptoMatch) {
    const baseSymbol = cryptoMatch[1];
    if (ASSET_NAMES[baseSymbol]) {
      return ASSET_NAMES[baseSymbol];
    }
  }
  
  // For pairs with slash like BTC/USDT, extract base
  if (cleanSymbol.includes('/')) {
    const baseSymbol = cleanSymbol.split('/')[0];
    if (ASSET_NAMES[baseSymbol]) {
      return ASSET_NAMES[baseSymbol];
    }
  }
  
  // For pairs with dash like BTC-USD, extract base
  if (cleanSymbol.includes('-')) {
    const baseSymbol = cleanSymbol.split('-')[0];
    if (ASSET_NAMES[baseSymbol]) {
      return ASSET_NAMES[baseSymbol];
    }
  }
  
  // Try with common variations
  const variations = [
    cleanSymbol,
    `${cleanSymbol}-USD`,
    `${cleanSymbol}/USD`,
    `${cleanSymbol}USD`,
  ];
  
  for (const variant of variations) {
    if (ASSET_NAMES[variant]) {
      return ASSET_NAMES[variant];
    }
  }
  
  // Return symbol if no name found
  return symbol;
};

export default ASSET_NAMES;
